export default "__VITE_ASSET__OzrLRsQi__"